import { RestError } from "../../services/rest-service/RestService";
import { useQuery } from "react-query";
import ReportingDataService from "../../services/reporting-data-service/ReportingDataService";
import { BaseUseQueryParameters } from "../BaseUseQueryParameters";
import { keys } from "./Keys";
import { IAvailableNotificationInfoDTO } from "../../services/reporting-data-service/ReportScheduleModels";

export type UseReportNotificationsQueryParameters = {
    groupID: number;
} & BaseUseQueryParameters<IAvailableNotificationInfoDTO>;

export function useReportNotifications({
    groupID,
    enabled,
    onError,
    onSuccess,
    refreshSeconds
}: UseReportNotificationsQueryParameters) {
    return useQuery<IAvailableNotificationInfoDTO, RestError>(
        keys.notifications(
            groupID
        ),
        ({ signal }) => {
            return ReportingDataService.getAvailableReportNotifications(

                groupID,
                signal
            );
        },
        {
            enabled: enabled,
            onError: onError,
            onSuccess: onSuccess,
            refetchInterval: refreshSeconds ? refreshSeconds * 1000 : false,
            staleTime: 0
        }
    );
}
